import { Bar } from '@ant-design/plots';
import React, { memo } from 'react';

function transform(question) {
  if (!question) return [];

  const data = [];

  const entries = Object.entries(question.optionsCountMap);

  for (const [option, count] of entries) {
    data.push({ option, count });
  }
  return data;
}

function QuestionChart({ question }) {
  if (!question) return null;

  switch (question.type) {
    case 'CHOICE_OF_OPTIONS': {
      const config = {
        data: transform(question),
        xField: 'count',
        yField: 'option',
        sort: {
          reverse: true,
        },
      };

      return <Bar {...config} xAxis={{ tickInterval: 1 }} />;
    }
    default:
      return null;
  }
}

const Memoized = memo(QuestionChart);

export { Memoized as QuestionChart };
